import { getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";

const baseApiUrl = resolveApiUrl("/search/save-search-term");

export const saveSearchTerm = async (term: string, url: string) => {
  return await fetch(baseApiUrl, {
    body: JSON.stringify({
      term: term,
      url: url,
    }),
    keepalive: true,
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
};
